import * as React from "react";
import { Button, Modal, RichTextArea } from "@grandvisionhq/common";
import { useIntl } from "@grandvisionhq/state";
/* empty css                              */
import { useCmsData } from "../../../../../../../../../../context/context/CmsContext.js";
const ContactLensesRxInfoModal = ({ className }) => {
  const { getLabel } = useIntl();
  const { contactLensesInfoModal } = useCmsData();
  const [isOpen, setIsOpen] = React.useState(false);
  if (!contactLensesInfoModal) {
    return null;
  }
  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Button,
    {
      className,
      variant: "ghost",
      onClick: openModal,
      caption: getLabel("products.contactLenses.prescription.link")
    }
  ), /* @__PURE__ */ React.createElement(Modal, { showIcon: true, isOpen, onModalClose: closeModal }, /* @__PURE__ */ React.createElement("div", { className: "contact-lenses-rx-info__modal" }, /* @__PURE__ */ React.createElement(RichTextArea, { content: contactLensesInfoModal }))));
};
export {
  ContactLensesRxInfoModal
};
//# sourceMappingURL=ContactLensesRxInfoModal.js.map
